import { StaticQuery, graphql } from 'gatsby'

import Background from '../components/background'
import Button from '../components/button'
import Post from '../components/post'
import React from 'react'
import Wrapper from '../components/wrapper'
import { css } from '@emotion/core'
import { minWidth } from '../breakpoints'

const margin = 30

export default ({ currentId }) => (
  <StaticQuery
    query={graphql`
      query {
        latest: allWordpressPost(
          sort: { fields: date, order: DESC }
          limit: 4
        ) {
          items: edges {
            item: node {
              wordpress_id
              link
              date(formatString: "DD MMMM YYYY", locale: "nl")
              fields: wordpress_fields {
                title
                image {
                  localFile {
                    childImageSharp {
                      fluid(maxHeight: 240, maxWidth: 380, quality: 80) {
                        ...GatsbyImageSharpFluid
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={({ image, latest: { items } }) => (
      <Background>
        <Wrapper>
          <div
            css={css`
              margin-bottom: 3.33rem;
              padding-top: 2.75rem;

              ${minWidth.medium} {
                align-items: center;
                display: flex;
                padding-top: 4rem;
                justify-content: space-between;
              }

              ${minWidth.laptop} {
                padding-top: 5.5rem;
              }
            `}
          >
            <h2
              css={css`
                ${minWidth.medium} {
                  margin: 0;
                }
              `}
            >
              Laatste blogberichten
            </h2>
            <Button to="/#blog" color="orange">
              Lees mijn blog
            </Button>
          </div>
          <div
            css={{
              display: 'flex',
              flexWrap: 'wrap',
              marginBottom: -margin,
              [minWidth.medium]: {
                marginRight: -margin,
              },
            }}
          >
            {items
              .filter(({ item }) =>
                currentId ? item.wordpress_id !== currentId : true
              )
              .slice(0, 3)
              .map(({ item }) => (
                <Post key={item.wordpress_id} item={item} margin={margin} />
              ))}
          </div>
        </Wrapper>
      </Background>
    )}
  />
)
